var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoElement",staticClass:"video-js",attrs:{"disablePictureInPicture":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }